import { render, staticRenderFns } from "./TLPLayout.vue?vue&type=template&id=95a13d4e&"
import script from "./TLPLayout.vue?vue&type=script&lang=js&"
export * from "./TLPLayout.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports